import React from 'react'

const Pagination = ({ticketsLength, project}) => {
  return ( 
    <div className='max-w-6xl flex px-10 justify-center container mx-auto pt-5'>
        <div className="flex flex-col items-center">
              <span className="text-sm text-gray-700">
                {project === "last_ten_escalations" ? "" : ""}
              </span>
        </div>
    </div>
  )
}

export default Pagination